import React from 'react'
import { useNavigate,Navigate } from 'react-router-dom';
import FetchSections from '../components/FetchSections';
import ReactDOM from 'react-dom';
import HeaderMenuList from '../components/HeaderMenuList';
import Header from '../partials/Header';

//import Google from './components/Google';
function Personalizesection() {

  document.body.classList.remove('personalize-author');
  document.body.classList.add('personalize-tag');

  const navigate = useNavigate();
  const handleCheckChange =(evnt)=>{
    if(evnt!==''){
      //console.log(evnt);
      const mytagsmenu = document.getElementsByClassName("mytagsmenu");
      if(mytagsmenu.length>0){
        for (let i = 0; i < mytagsmenu.length; i++) {
          ReactDOM.render(
            <React.StrictMode>
              <HeaderMenuList />
            </React.StrictMode>,
             document.getElementsByClassName("mytagsmenu")[i]
          );
        }
    
        }
      navigate('/personalize-newsletter');
    }
    //  navigate('/personalize-newsletter');
    }
    if (!localStorage.getItem('user-info')) {
    
      return <Navigate to="/" />
    
  }else{ return (
    <>
    <Header backhref="#/personalize-author" skiphref="#/personalize-newsletter" /> 
     <main>
      <div className="grid-container">
      <FetchSections samirCallback = {handleCheckChange}  />
      </div>
    </main>
    </>
  );
  }

}

export default Personalizesection;

